import { BillOfLadingLogEdit } from './BillOfLadingLogEdit';

export default BillOfLadingLogEdit;
